import { render } from "./services.vue?vue&type=template&id=17b03800&scoped=true"
import script from "./services.vue?vue&type=script&lang=js"
export * from "./services.vue?vue&type=script&lang=js"

import "./services.vue?vue&type=style&index=0&id=17b03800&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-17b03800"

export default script